// ****** We can't use craco aliases in this file because it is used in the service worker, so we have to use relative paths
import * as keyMenu from './KeyMenu';
import * as typeMode from './AccessTypeMode';

// For each new redirect page we need to create a new MD5 Hash
// Each hash will identify a page, you can create it here https://www.md5hashgenerator.com/
// Put the name of the page and generate the hash
// guid: Unique identify to a page
// accessMode: what access type mode required typeMode.Employee / typeMode.Supervisor
// page: Put the enum that represents the page
export const RedirectType = [
    {
        guid: 'bd2304b0a86ce5a4fadd53fefc4f259e',//RequestApprobation
        accessMode: typeMode.Employee,
        page: keyMenu.MENU_DOCUMENTS
    },
    {
        guid: '140685b8f5c6b18ddb68c087c31ea975',
        accessMode: typeMode.Supervisor,
        page: keyMenu.MENU_SUP_PUNCHAPPROVAL
    }
]